import { css, useTheme } from "@emotion/react";

import Stack from "./Stack.jsx";
import useComputedCSSGridColumns from "./useComputedCSSGridColumns";

import { useThemeProps } from "./index";

export default function MixedGridLayout(props) {
  props = useThemeProps({ props, name: "MixedGridLayout" });

  let {
    columnMinWidth = 80,
    columnGap = 6,
    rowGap = 4,
    className,
    items,
    renderItem,
    ...restProps
  } = props;

  const theme = useTheme();
  // let items = Children.toArray(children);
  columnMinWidth = theme.getLength(columnMinWidth);
  columnGap = theme.getLength(columnGap);
  rowGap = theme.getLength(rowGap);

  const [columns = [], ref] = useComputedCSSGridColumns([
    columnMinWidth,
    columnGap,
    className,
    // JSON.stringify(styles),
  ]);

  let groups = columns.map((column) => ({
    ...column,
    items: [],
  }));

  if (columns.length) {
    items.forEach((item, index) => {
      let group = groups[Math.min(index, groups.length - 1)];
      group.items.push(item);
    });
  }

  let itemIndex = 0;

  return (
    <div
      className={className}
      ref={ref}
      {...restProps}
      css={css`
        display: grid;
        grid-template-columns: repeat(
          auto-fit,
          minmax(min(100%, ${columnMinWidth}), 1fr)
        );
        row-gap: ${rowGap};
        column-gap: ${columnGap};
        align-items: stretch;
      `}
    >
      {groups.map(({ items, ...columnProps }, columnIndex) => {
        if (!items.length) return null;
        return (
          <Stack
            direction="column"
            spacing={rowGap}
            key={columnIndex}
            justifyContent="start"
          >
            {items.map((item, columnItemIndex) => {
              return renderItem(item, {
                isFirstColumn: columnIndex === 0,
                isLastColumn: columnIndex === groups.length - 1,
                isFirstItem: itemIndex === 0,
                isFirstColumnItem: columnItemIndex === 0,
                itemIndex: itemIndex++,
                columnIndex,
                columnItemIndex,
                columnItemCount: items.length,
                columnCount: columns.length,
                ...columnProps,
              });
            })}
          </Stack>
        );
      })}
    </div>
  );
}
